module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/algoliasearch/src/clone.js